import './globals.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { initSentry, ErrorBoundary } from '@/lib/sentry'
import { installChunkErrorReporting } from '@/lib/chunkRecovery'
import SentryErrorFeedback from '@/components/SentryErrorFeedback'

initSentry()
installChunkErrorReporting()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      fallback={({ eventId }) => (
        <SentryErrorFeedback eventId={eventId} />
      )}
    >
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>
)
